


























import { Prop, Component, Vue } from "vue-property-decorator";
import { FolderEntry } from "@/models/file";

import VDelete from "@/components/VDelete.vue";
import VRename from "@/components/file/VRename.vue";

@Component({
  components: {
    VDelete,
    VRename
  }
})
export default class VFolderEntry extends Vue {
  @Prop({ required: true }) entry!: FolderEntry;

  get src() {
    if (!this.entry.image) {
      return "https://fakeimg.pl/75x100/";
    }
    return this.entry.image;
  }

  get name() {
    return this.entry.name;
  }

  rename(name: string) {
    this.$emit("rename", this.entry, name);
  }

  remove() {
    this.$emit("remove", this.entry);
  }
}
